module.exports = __webpack_public_path__ + "media/admiralbob77-Isolation-Swing-5_compressed.092db4c4.mp3";